<template>
  <div class="body-type-modal flex">
    <div class="images flex">
      <div class="images__item">
        <span class="images__item--title">Chest vs.<br /> Hips</span>
        <div class="images__item--img">
          <img :src="`/img/survey/breast-vs-hips/breast-vs-hips-${toText(bodyType.breast_vs_hips)}.png`" alt="">
        </div>
        <span class="images__item--value capitalize">
          {{ toText(bodyType.breast_vs_hips) }}
        </span>
      </div>
      <div class="images__item">
        <span class="images__item--title">Waist vs.<br /> Hips</span>
        <div class="images__item--img">
          <img :src="`/img/survey/waist-vs-hips/waist-vs-hips-${toText(bodyType.waist_vs_hips)}.png`" alt="">
        </div>
        <span class="images__item--value capitalize">
          {{ toText(bodyType.waist_vs_hips) }}
        </span>
      </div>
      <div class="images__item">
        <span class="images__item--title">Chest vs.<br /> Waist</span>
        <div class="images__item--img">
          <img :src="`/img/survey/breast-vs-waist/breast-vs-waist-${toText(bodyType.breast_vs_waist)}.png`" alt="">
        </div>
        <span class="images__item--value capitalize">
          {{ toText(bodyType.breast_vs_waist) }}
        </span>
      </div>
    </div>
    <div class="howto flex flex-column align-center flex-fill very-small-padding">
      <span>How to style:</span>
      <h3 class="howto--title capitalize no-margin-top very-small-margin-bottom">{{ bodyType.type }}</h3>
      <p class="howto--description">
        {{ howTo[bodyType.image] }}
      </p>
    </div>
  </div>
</template>

<script>
import { howTo } from './bodyTypes'
export default {
  name: 'BodyTypeModal',

  props: {
    bodyType: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    howTo
  }),

  methods: {
    toText (input) {
      switch (Number(input)) {
        case 1:
          return 'smaller'
        case 2:
          return 'same'
        case 3:
          return 'wider'
        default:
          return 'None'
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .images {
    &__item {
      position: relative;
      padding: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      &--title {
        font-size: 20px;
        font-weight: 500;
        z-index: 2;
      }

      &--img {
        width: 150px;
        height: 200px;
        border: 1px solid pink;
        padding: 10px;
        margin-top: -10px;
        padding-bottom: 30px;

        img {
          max-height: 100%;
          max-width: 100%;
        }
      }

      &--value {
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        font-weight: 600;
      }
    }
  }

  .howto {

    &--title {
      font-size: 24px;
    }

    &--description {
      font-size: 20px;
      line-height: 24px;
      text-align: center;
    }
  }
</style>
